import { render, staticRenderFns } from "./CadastroSinonimos.vue?vue&type=template&id=6cf074f0&"
import script from "./CadastroSinonimos.vue?vue&type=script&lang=js&"
export * from "./CadastroSinonimos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports